import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/operating-centers/create',
    name: 'operatingCenterCreate',
    component: () =>
      import(
        '@/views/restricted/key-account-networks/operating-center/OperatingCenterCreateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_OPERATING_CENTER_CREATE_PERMISSION'],
      menuSelected: 'key-account-networks'
    }
  },
  {
    path: '/operating-centers/:operatingCenterId/edit',
    name: 'operatingCenterUpdate',
    component: () =>
      import(
        '@/views/restricted/key-account-networks/operating-center/OperatingCenterUpdateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_OPERATING_CENTER_UPDATE_PERMISSION'],
      menuSelected: 'key-account-networks'
    }
  },
  {
    path: '/operating-centers/:operatingCenterId',
    name: 'operatingCenterDetail',
    component: () =>
      import(
        '@/views/restricted/key-account-networks/operating-center/OperatingCenterDetailLayoutView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_OPERATING_CENTER_READ_PERMISSION'],
      menuSelected: 'key-account-networks'
    }
  }
]
